import { AdminMembersReportFeedsTableRowFragment$key } from "@/admin/insights/member-reports/tabs/discussions/__generated__/AdminMembersReportFeedsTableRowFragment.graphql"
import { useLabel } from "@/core/context/LabelsContext"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoIcon, DiscoTable, DiscoText } from "@disco-ui"
import { TableCell } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { graphql, useFragment } from "react-relay"

interface Props {
  feedKey: AdminMembersReportFeedsTableRowFragment$key
}

function AdminMembersReportFeedsTableRow({ feedKey }: Props) {
  const classes = useStyles()
  const organizationLabel = useLabel("organization")
  const feed = useFragment<AdminMembersReportFeedsTableRowFragment$key>(
    graphql`
      fragment AdminMembersReportFeedsTableRowFragment on Feed
      @argumentDefinitions(organizationMembershipId: { type: "ID!" }) {
        id
        name
        product {
          name
        }
        totalComments(organizationMembershipId: $organizationMembershipId)
        totalReactions(organizationMembershipId: $organizationMembershipId)
      }
    `,
    feedKey
  )

  return (
    <DiscoTable.Row>
      {/* Feed Name */}
      <TableCell>
        <div className={classes.nameContainer}>
          <DiscoIcon icon={"iconsax.custom-widget-alt"} />
          <DiscoText variant={"body-sm"}>{feed.name}</DiscoText>
        </div>
      </TableCell>

      {/* Location */}
      <TableCell>
        <DiscoText variant={"body-sm"}>
          {feed.product?.name || organizationLabel.singular}
        </DiscoText>
      </TableCell>

      {/* Comments */}
      <TableCell>{feed.totalComments || "-"}</TableCell>

      {/* Reactions */}
      <TableCell>{feed.totalReactions || "-"}</TableCell>
    </DiscoTable.Row>
  )
}

const useStyles = makeUseStyles((theme) => ({
  nameContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}))

export function AdminMembersReportFeedsTableRowSkeleton() {
  return (
    <DiscoTable.Row>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
    </DiscoTable.Row>
  )
}

export default AdminMembersReportFeedsTableRow
